export default __webpack_public_path__ + "static/media/telegram.0dc35c6a.png";